// constants
import { SELECTORS } from '@/scripts/constants';

// assets
import './cropBlock.scss';

export function cropBlock() {
  document.querySelectorAll('[data-crop-block]')
    .forEach((block) => {
      const trigger = block.querySelector('[data-trigger]');
      trigger.addEventListener('mouseenter', () => {
        block.classList.add(SELECTORS.active);
      });
      block.addEventListener('mouseleave', () => {
        block.classList.remove(SELECTORS.active);
      });
    });
}
